export default "/assets/images/performance-filter-img-03.f06753ec68f062d7.webp";